export const C = {
  bg: "#10191d",
  surface: "#131f24",
  card: "#19242b",
  border: "rgba(255,255,255,0.12)",
  borderHover: "rgba(249,115,22,0.35)",
  accent: "#f97316",
  accentDim: "rgba(249,115,22,0.10)",
  accentBorder: "rgba(249,115,22,0.28)",
  text: "#f7f3ea",
  muted: "rgba(247,243,234,0.68)",
  faint: "rgba(247,243,234,0.34)",
  green: "#22c55e",
  progress: "#f97316",
  red: "#ef4444",
  blue: "#3b82f6",
  yellow: "#eab308",
  purple: "#a855f7",
};

export const LEVELS = ["N5", "N4", "N3", "N2", "N1"];
export const WORD_TYPES = ["noun", "verb", "adj", "adverb", "particle", "expression"];

export const LEVEL_COLORS = {
  N5: "#f97316", N4: "#eab308", N3: "#22c55e", N2: "#3b82f6", N1: "#a855f7",
};
